// extracted by mini-css-extract-plugin
export default {"root":"PaymentFooter__root--H0xoS","root_mobile":"PaymentFooter__root_mobile--EjdeU","inline":"PaymentFooter__inline--3NrvG"};